import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=0d826b08&scoped=true&"
import script from "./EmailPreview.vue?vue&type=script&lang=js&"
export * from "./EmailPreview.vue?vue&type=script&lang=js&"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=0d826b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d826b08",
  null
  
)

export default component.exports